import React, { Component } from 'react';
import WidgetModalForm, { ModalFormContext } from '../../../components/Modal/modalForm.component';
import ModalVisualizaHistoricoEntradaARP from './visualizaHistoricoDacaEntrada/visualizaHistoricoDacaEntradaARP.modal';
import ModalVisualizaHistoricoEntradaDefesaCivil from './visualizaHistoricoDacaEntrada/visualizaHistoricoDacaEntradaDefesaCivil.modal';
import ModalVisualizaHistoricoEntradaEmergencial from './visualizaHistoricoDacaEntrada/visualizaHistoricoDacaEntradaEmergencial.modal';
import ModalVisualizaHistoricoMovimentacao from './visualizaHistoricoDacaMovimentacao/visualizaHistoricoDacaMovimentacao.modal';
import ModalVisualizaHistoricoDevolucao from './visualizaHistoricoDacaDevolucao/visualizaHistoricoDacaDevolucao.modal';
import ModalVisualizaHistoricoSaida from './visualizaHistoricoDacaSaida/visualizaHistoricoDacaSaida.modal';
import ModalVisualizaHistoricoReserva from './visualizaHistoricoDacaReserva/visualizaHistoricoDacaReserva.modal';

export default class ModalVisualizaHistoricoDaca extends Component {
	constructor(props) {
		super(props);
		this.state = {
		};
		this.columns = [];
		this.actions = [];
	}

	componentDidMount() {
		const { transacao } = this.props;

		/* Ordenação das CREPDECs atendidas pelo nome em ordem alfabética
		*/
		if (transacao && transacao.destinoEstoque
			&& transacao.destinoEstoque.crepdecs
			&& transacao.destinoEstoque.crepdecs.length) {
			transacao.destinoEstoque.crepdecs.sort((a, b) => a.nome.localeCompare(b.nome));
		}
	}

	render() {
		const {
			props: {
				isOpenVisualizar,
				handleCloseVisualizar,
				transacao,
				isDacaPermanente,
			},
		} = this;

		return (
			<WidgetModalForm
				initialValues={transacao}
				iconCancelar='fas fa-times'
				textCancelar='Fechar'
				title='Visualizar transação'
				isOpen={isOpenVisualizar}
				cancelar={handleCloseVisualizar}
				tamanho='lg'
				isVisualizarTransacao
				dataAlteracao={transacao.dataAlteracao}
			>
				<ModalFormContext.Consumer>
					{({ values }) => (
						<React.Fragment>
							<div className='row'>
								<div className='col-md-12 pl-0 pr-0'>
									{/* Corpo da modal de visualizar transação de entrada (tb será componentizado) */}
									{values.tipoTransacao !== null && values.tipoTransacao === 'ENTRADA' && (
										<React.Fragment>
											{transacao.destinoEstoque.tipoEstoque === 'ARP'
												&& (<ModalVisualizaHistoricoEntradaARP transacao={transacao} />)
											}

											{transacao.destinoEstoque.tipoEstoque === 'COMPRA_EMERGENCIAL'
												&& (<ModalVisualizaHistoricoEntradaEmergencial transacao={transacao} />)}

											{transacao.destinoEstoque.tipoEstoque === 'ESTOQUE_DACA'
												&& (<ModalVisualizaHistoricoEntradaDefesaCivil transacao={transacao} />)}
										</React.Fragment>
									)}

									{/* Corpo da modal de visualizar transação de saida */}
									{values.tipoTransacao !== null && (values.tipoTransacao === 'SAIDA' || values.tipoTransacao === 'DESCARTE' || values.tipoTransacao === 'SAIDA_PDR') && (
										<React.Fragment>
											<ModalVisualizaHistoricoSaida
												transacao={values}
												isDacaPermanente={isDacaPermanente}
											/>
										</React.Fragment>
									)}

									{/* Corpo da modal de visualizar transação de movimentacao */}
									{values.tipoTransacao !== null && values.tipoTransacao === 'MOVIMENTACAO' && (
										<React.Fragment>
											<ModalVisualizaHistoricoMovimentacao
												transacao={values}
											/>
										</React.Fragment>
									)}

									{/* Corpo da modal de visualizar transação de devolução */}
									{values.tipoTransacao !== null && values.tipoTransacao === 'DEVOLUCAO' && (
										<React.Fragment>
											<ModalVisualizaHistoricoDevolucao
												transacao={values}
											/>
										</React.Fragment>
									)}

									{/* Corpo da modal de visualizar transação de reserva */}
									{values.tipoTransacao !== null && values.tipoTransacao === 'RESERVA_PDR' && (
										<React.Fragment>
											<ModalVisualizaHistoricoReserva
												transacao={values}
											/>
										</React.Fragment>
									)}

								</div> {/* col-md-12 pl-0 pr-0 */}
							</div> {/* .row */}
						</React.Fragment>
					)}
				</ModalFormContext.Consumer>
			</WidgetModalForm>
		);
	}
}
